import { useEffect } from "react";
import { setSEO } from "../utils/seo";

export default function BadCreditCarLoans() {

  useEffect(() => {
    setSEO({
      title: "Bad Credit Car Loans Canada | Easy Approval - YesAuto",
      description:
        "Get approved for bad credit car loans in Canada. Fast approval, no credit history required. Apply online with YesAuto today.",
    });
  }, []);

  return (
    <div className="p-6">

      <h1 className="text-3xl font-bold mb-4">
        Bad Credit Car Loans Canada
      </h1>

      <p className="mb-6">
        Struggling with bad credit? YesAuto helps you get approved for car
        financing in Canada quickly and easily. No stress, no complicated
        process — just simple and fast approval.
      </p>

      <h2 className="text-2xl font-semibold mb-2">Why Choose YesAuto?</h2>
      <ul className="mb-6 list-disc pl-6">
        <li>Fast approval process</li>
        <li>All credit types accepted</li>
        <li>No hidden fees</li>
        <li>Simple and secure application</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">Who Can Apply?</h2>
      <ul className="mb-6 list-disc pl-6">
        <li>People with bad credit</li>
        <li>No credit history</li>
        <li>New immigrants in Canada</li>
        <li>Low income applicants</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">How It Works</h2>
      <ol className="mb-6 list-decimal pl-6">
        <li>Fill out our quick online application</li>
        <li>Get approved within minutes</li>
        <li>Drive your car with easy financing</li>
      </ol>

      <h2 className="text-2xl font-semibold mb-2">Apply Now</h2>
      <p className="mb-4">Apply in just 2 minutes. No obligation.</p>

      <a
        href="/apply"
        className="bg-blue-600 text-white px-6 py-3 rounded-lg"
      >
        Apply Now
      </a>

    </div>
  );
}